// src/schema/preChemoCheckupSchema.js
import * as Yup from "yup";

export const preChemoCheckupSchema = Yup.object().shape({
    checkupDate: Yup.date()
        .required("Date of check up is required")
        .typeError("Invalid date format"),

    ecogStatus: Yup.string()
        .required("ECOG PS is required")
        .matches(/^[0-5]$/, "ECOG PS must be between 0 and 5"),
});